import { useEffect, useState } from "react";
import axios from "axios";

let cached = null;

// Live number of open stores (same list as the public Locations page); shown as "N+"
export const useStoreCount = (fallback = 48) => {
  const [n, setN] = useState(cached ?? fallback);
  useEffect(() => {
    if (cached) return;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/locations/stats`)
      .then((r) => { cached = r.data.store_count; if (cached) setN(cached); }).catch(() => {});
  }, []);
  return n;
};
